import * as React from 'react';

import './form-required-mark.scss';

type Props = {};

class FormRequiredMark extends React.PureComponent<Props> {
  render(): React.ReactNode {
    return (
      <span className="form-required-mark">*</span>
    );
  }
}

export default FormRequiredMark;
